const overflow = {
    name: "overflow",
    path: "/overflow",
    title: "overflow",
    description: "Utilities for controlling how a replaced element's content should be positioned within its container.",
    value: {
        'overflow': {
          "overflow-auto": "auto",
          "overflow-hidden": "hidden",
          "overflow-visible": "visible",
          "overflow-scroll": "scroll",
        },
        'overflow-x': {
          "overflow-x-hidden": "hidden",
          "overflow-x-visible": "visible",
          "overflow-x-scroll": "scroll",
          "overflow-x-auto": "auto",
        },
        'overflow-y': {
          "overflow-y-hidden": "hidden",
          "overflow-y-visible": "visible",
          "overflow-y-scroll": "scroll",
          "overflow-y-auto": "auto",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="overflow-visible ...">
  <!-- ... -->
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="overflow-hidden ...">
  <!-- ... -->
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="overflow-auto ...">
  <!-- ... -->
</div>
                `
            },
        },
         {
            "example": {
                "code": `
<div class="overflow-x-auto ...">
  <!-- ... -->
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">overflow-visible</code>
                  utility to prevent content within an element from being clipped:
            </p>
            <div class="relative mx-auto flex max-w-sm items-center gap-6 overflow-visible rounded-xl bg-white shadow-lg ring-1 ring-color-black/5 dark:bg-color-gray-800">
                <img class="absolute -left-6 h-24 w-24 rounded-full shadow-lg" src="https://randomuser.me/api/portraits/men/66.jpg">
                <div
                class="flex flex-col py-5 pl-24"><strong class="text-sm font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="text-sm font-medium text-color-gray-500 dark:text-color-gray-400">Technical advisor</span></div>
            </div>
            
            `
        },
                {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">overflow-hidden</code>
                  utility to clip any content within an element that overflows the bounds of that element:
            </p>
            <div class="relative mx-auto flex max-w-sm items-center gap-6 overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-color-black/5 dark:bg-color-gray-800">
                <img class="absolute -left-6 h-24 w-24 rounded-full shadow-lg" src="https://randomuser.me/api/portraits/men/66.jpg">
                <div
                class="flex flex-col py-5 pl-24"><strong class="text-sm font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="text-sm font-medium text-color-gray-500 dark:text-color-gray-400">Technical advisor</span></div>
            </div>
            
            `
        },
         {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">overflow-auto</code>
                  utility to add scrollbars to an element in the event that its content overflows the bounds of that element:
            </p>
            <div class="relative mx-auto flex h-72 max-w-sm flex-col divide-y divide-dashed divide-color-gray-200 overflow-auto rounded-xl bg-color-white shadow-lg ring-1 ring-color-black/5 dark:divide-color-gray-200/5 dark:bg-color-gray-800">
                    <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src="https://randomuser.me/api/portraits/men/66.jpg">
                        <div
                        class="flex flex-col"><strong class="text-sm font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Technical advisor</span></div>
                </div>
                <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src="https://randomuser.me/api/portraits/men/9.jpg">
                    <div
                    class="flex flex-col"><strong class="text-sm font-medium text-gray-900 dark:text-gray-200">Debra Houston</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Analyst</span></div>
                </div>
                <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src="https://randomuser.me/api/portraits/men/19.jpg">
                    <div
                    class="flex flex-col"><strong class="text-sm font-medium text-gray-900 dark:text-gray-200">Jane White</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Director, Marketing</span></div>
                </div>
                <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src="https://randomuser.me/api/portraits/men/14.jpg">
                    <div
                    class="flex flex-col"><strong class="text-sm font-medium text-gray-900 dark:text-gray-200">Ray Flint</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Technical Advisor</span></div>
                </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">overflow-x-auto</code>
                  utility to add scrollbars to an element in the event that its content overflows the bounds of that element:
            </p>
            <div class="relative mx-auto flex max-w-md divide-x divide-dashed divide-color-gray-200 overflow-x-auto rounded-xl bg-color-white shadow-lg ring-1 ring-color-black/5 dark:divide-color-gray-200/5 dark:bg-color-gray-800">
                    <div class="flex-none text-center px-3 py-6 first:pl-6 last:pr-6">
                        <img class="size-18 rounded-full" src="https://randomuser.me/api/portraits/men/66.jpg">
                        <p class="text-sm  mt-3 font-medium text-color-gray-900 dark:text-color-gray-200">Andrew</p>
                </div>
                <div class="flex-none text-center px-3 py-6 first:pl-6 last:pr-6">
                <img class="size-18 rounded-full" src="https://randomuser.me/api/portraits/men/9.jpg">
                    <p class="text-sm mt-3  font-medium text-gray-900 dark:text-gray-200">Debra</p>
                </div>
                <div class="flex-none text-center px-3 py-6 first:pl-6 last:pr-6">
                <img class="size-18 rounded-full" src="https://randomuser.me/api/portraits/men/19.jpg">
                    <p class="text-sm mt-3  font-medium text-gray-900 dark:text-gray-200">Jane</p>
                </div>
                <div class="flex-none text-center px-3 py-6 first:pl-6 last:pr-6"><img class="size-18 rounded-full" src="https://randomuser.me/api/portraits/men/14.jpg">
                    <p class="text-sm mt-3  font-medium text-gray-900 dark:text-gray-200">Ray</p>
                </div>
                <div class="flex-none text-center px-3 py-6 first:pl-6 last:pr-6"><img class="size-18 rounded-full" src="https://randomuser.me/api/portraits/men/66.jpg">
                        <p class="text-sm mt-3  font-medium text-color-gray-900 dark:text-color-gray-200">Andrew</p>
                </div>
                <div class="flex-none text-center px-3 py-6 first:pl-6 last:pr-6"><img class="size-18 rounded-full" src="https://randomuser.me/api/portraits/men/9.jpg">
                    <p class="text-sm mt-3  font-medium text-gray-900 dark:text-gray-200">Debra</p>
                </div>
            </div>
            
            `
        },
    ]
};

export default overflow;

<div className="sr-only">
    <div class="relative overflow-hidden max-w-md mx-auto mt-3 flex max-w-sm items-center overflow-x-auto gap-6 overflow-visible rounded-xl bg-white shadow-lg ring-1 ring-color-black/5 dark:bg-color-gray-800">
        <img class="absolute -left-6 h-24 w-24 divide-x rounded-full shadow-lg" src="https://randomuser.me/api/portraits/men/66.jpg"/>
        <div
        class="flex flex-col gap-2 py-5 pl-24"><strong class="text-sm font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="text-sm font-medium text-color-gray-500 dark:text-color-gray-400">Technical advisor</span></div>
    </div>
    <div class="relative mx-auto flex h-72 max-w-sm flex-col divide-y divide-dashed divide-color-gray-200 overflow-auto rounded-xl bg-color-white shadow-lg ring-1 ring-color-black/5 dark:divide-color-gray-200/5 dark:bg-color-gray-800">
                    <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 size-18 rounded-full" src=""/>
                        <div
                        class="flex flex-col"><strong class="text-sm font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Technical advisor</span></div>
                </div>
                <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src=""/>
                    <div
                    class="flex flex-col flex-none px-3 py-6 first:pl-6 last:pr-6"><strong class="text-sm font-medium text-gray-900 dark:text-gray-200">Debra Houston</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Analyst</span></div>
                </div>
                <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src=""/>
                    <div
                    class="flex flex-col"><strong class="text-sm font-medium text-gray-900 dark:text-gray-200">Jane White</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Director, Marketing</span></div>
                </div>
                <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src=""/>
                    <div
                    class="flex flex-col"><strong class="text-sm font-medium text-gray-900 dark:text-gray-200">Ray Flint</strong><span class="text-sm font-medium text-gray-500 dark:text-gray-400">Technical Advisor</span></div>
                </div>
            </div>
</div>